import { render, staticRenderFns } from "./game-swiper.vue?vue&type=template&id=7a404614&scoped=true"
import script from "./game-swiper.vue?vue&type=script&lang=js"
export * from "./game-swiper.vue?vue&type=script&lang=js"
import style0 from "./game-swiper.vue?vue&type=style&index=0&id=7a404614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a404614",
  null
  
)

export default component.exports